import React from 'react';
import { getLocalStorageItem } from '../../utils/cookieAndLocalStorageUtils';

const { REACT_APP_LUCServerUrl } = process.env;

class Login extends React.Component {
  componentDidMount() {
    if (getLocalStorageItem('access_token')) {
      this.props.history.push('/dashboard/units');
      return;
    }

    const redirectUri = window.location.origin + '/auth/callback';
    const lucLoginUrl = `${REACT_APP_LUCServerUrl}login/#/main?redirect_uri=${encodeURIComponent(redirectUri)}`;
    window.location.href = lucLoginUrl;
  }

  render() {
    return null;
  }
}

export { Login };
